import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Button,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import ListReturnBook from "./ListReturnBook";
import {
  SelectAcademicYear,
  SelectStudent,
  SelectStudentByAcademicYear,
  SelectWarehouse,
} from "../Include/DynamicSelect";

import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  CREATE_STUDENT_RETURN_RENT_MATERIAL,
  UPDATE_RETURN_RENT_MATERIAL,
} from "../../Schema/StudentRent";

export default function ReturnStudentRent({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  //
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [studentVal, setStudentVal] = useState({ id: "", title: "" });
  const [warehouseVal, setWarehouseVal] = useState({ id: "", title: "" });
  const [requiredField, setRequiredField] = useState(false);

  // =============== List Item Set ===================
  const book = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    condition: "",
    returnMaterial: [],
    key: Date.now() + Math.random(),
  };

  const [bookList, setBookList] = useState([book]);

  const handleAddListBook = () => {
    setBookList([...bookList, book]);
  };

  const handleAddListSubBook = (mainKey) => {
    //
    const newBook = bookList?.map((d) => {
      if (mainKey === d?.key) {
        //
        if (d.returnMaterial?.length > 0) {
          let newArray = d.returnMaterial;
          d.returnMaterial = [
            ...newArray,
            {
              key: Date.now() + Math.random(),
              isOld: false,
              isUpdate: false,
              condition: "",
              qty: 0,
              desc: "",
              warehouseId: {
                id: "",
                title: "",
              },
            },
          ];
        } else {
          d.returnMaterial = [
            {
              key: Date.now() + Math.random(),
              isOld: false,
              isUpdate: false,
              condition: "",
              qty: 0,
              desc: "",
              warehouseId: {
                id: "",
                title: "",
              },
            },
          ];
        }
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleUpdateListBook = (key, val, fieldName) => {
    const newBook = bookList?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = val;
        }
        if (key === d.key && fieldName === "qty") {
          d.qty = parseFloat(val);
        }
        if (key === d.key && fieldName === "condition") {
          d.condition = val;
        }
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleUpdateListSubBook = (key, subKey, returnId, val, fieldName) => {
    setRequiredField(false);
    //
    const newBook = bookList?.map((d) => {
      if (key === d?.key && d?.returnMaterial?.length > 0) {
        d.returnMaterial = d?.returnMaterial?.map((subReturn) => {
          if (subReturn?.key === subKey && fieldName === "condition") {
            subReturn.condition = val;
          }

          if (subReturn?.key === subKey && fieldName === "qty") {
            subReturn.qty = val;
          }

          if (subReturn?.key === subKey && fieldName === "warehouseId") {
            subReturn.warehouseId = val || { id: "", title: "" };
          }

          if (subReturn?.returnId === returnId && fieldName === "returnDate") {
            subReturn.returnDate = val;
          }

          if (subReturn?.returnId === returnId && fieldName === "isUpdate") {
            subReturn.isUpdate = val;
          }

          return subReturn;
        });
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleUpdateListSubBookChange = (
    key,
    subKey,
    returnId,
    val,
    fieldName,
  ) => {
    setRequiredField(false);
    //
    const newBook = bookList?.map((d) => {
      if (d?.returnMaterial?.length > 0) {
        d.returnMaterial = d?.returnMaterial?.map((subReturn) => {
          if (subReturn?.returnId === returnId && fieldName === "returnDate") {
            subReturn.returnDate = val;
          }

          if (subReturn?.returnId === returnId && fieldName === "isUpdate") {
            subReturn.isUpdate = val;
          }

          return subReturn;
        });
      }
      return d;
    });
    setBookList(newBook);
  };

  const handleDeleteListBook = (key) => {
    const handleDeleteList = bookList?.filter((d) => d.key !== key);
    setBookList([...handleDeleteList]);
  };

  const handleDeleteSubList = (key, subKey) => {
    setRequiredField(false);
    //
    const handleDeleteList = bookList?.filter((d) => {
      if (d.key === key) {
        d.returnMaterial = d?.returnMaterial?.filter((e) => e.key !== subKey);
      }
      return d;
    });
    setBookList([...handleDeleteList]);
  };
  // ================== End List Item =================

  // ===================  =============================
  const [updateReturnRentMaterial] = useMutation(UPDATE_RETURN_RENT_MATERIAL, {
    onCompleted: ({ updateReturnRentMaterial }) => {
      setRefetch();
    },
    onError: (error) => {
      console.log("error:::", error.message);
    },
  });

  const handleUpdateOldReturn = (key, subKey, returnId, val, fieldName) => {
    let returnRentMaterialItemsToSubmit = [];
    let returnBy = "";
    let returnDate = "";
    let receiveBy = "";

    bookList?.map((d) => {
      if (d?.returnMaterial?.length > 0) {
        d?.returnMaterial?.map((row) => {
          //
          if (
            row?.isOld === true &&
            row?.isUpdate === true &&
            row?.returnId === returnId
          ) {
            returnBy = row?.returnBy;
            returnDate = row?.returnDate;
            receiveBy = row?.receiveBy;

            returnRentMaterialItemsToSubmit.push({
              returnRentMaterialId: returnId,
              rentMaterialItemId: d?.rentMaterialItemId,
              warehouseId: row?.warehouseId?.id,
              condition: row?.condition,
              qty: parseFloat(row?.qty || 0),
              desc: "",
            });
          }
        });
      }
    });

    console.log("returnRentMaterialItemsToSubmit::", {
      id: returnId,
      input: {
        returnBy: returnBy,
        returnDate: returnDate,
        desc: "",
        receiveBy: receiveBy,
        returnRentMaterialItems: returnRentMaterialItemsToSubmit,
      },
    });

    if (returnRentMaterialItemsToSubmit?.length === 0) {
      return;
    }

    // =============== =================
    if (returnId) {
      updateReturnRentMaterial({
        variables: {
          id: returnId,
          input: {
            returnBy: returnBy,
            returnDate: returnDate,
            desc: "",
            receiveBy: receiveBy,
            returnRentMaterialItems: returnRentMaterialItemsToSubmit,
          },
        },
        onCompleted: ({ updateReturnRentMaterial }) => {
          console.log("updateReturnRentMaterial::::", updateReturnRentMaterial);
          handleUpdateListSubBookChange(key, subKey, returnId, val, fieldName);
        },
        onError: (error) => {
          console.log("error", error.message);
        },
      });
    }
  };

  // ================= Function Create Student Book ===============
  const [createReturnRentMaterial] = useMutation(
    CREATE_STUDENT_RETURN_RENT_MATERIAL,
    {
      onCompleted: ({ createReturnRentMaterial }) => {
        setLoading(false);
        if (createReturnRentMaterial?.status) {
          setAlert(true, "success", createReturnRentMaterial?.message);
          handleClose();
          resetForm();
          setRefetch();
          setBookList([book]);
          setStudentVal({ id: "", title: "" });
          setWarehouseVal({ id: "", title: "" });
        } else {
          setAlert(true, "error", createReturnRentMaterial?.message);
          console.log("error");
        }
      },
      onError: (error) => {
        setLoading(false);
        console.log("error", error?.message);
        setAlert(true, "error", error?.message);
      },
    },
  );

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required("require!"),
    studentId: Yup.string().required("require!"),
    remark: Yup.string(),
    returnDate: Yup.date().required("require!"),
    returnStatus: Yup.string().required("require!"),
    returnBy: Yup.string().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      studentId: "",
      remark: "",
      returnDate: new Date(),
      returnStatus: "",
      returnBy: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      //
      // console.log("bookList:::", bookList);
      //
      let returnRentMaterialItemsToSubmit = [];
      bookList?.map((d) => {
        if (d?.returnMaterial?.length > 0) {
          d?.returnMaterial?.map((row) => {
            //
            if (row?.isOld === false) {
              returnRentMaterialItemsToSubmit.push({
                rentMaterialItemId: d?.rentMaterialItemId,
                warehouseId: row?.warehouseId?.id,
                condition: row?.condition,
                qty: parseFloat(row?.qty || 0),
                desc: "",
              });
            }
          });
        }
      });

      // console.log("returnRentMaterialItemsToSubmit", returnRentMaterialItemsToSubmit);

      if (returnRentMaterialItemsToSubmit?.length === 0) {
        return;
      }

      // ============  Check Require Field  =============
      let createStatus = false;
      const BreakException = {};
      try {
        returnRentMaterialItemsToSubmit?.forEach(function (elem) {
          if (
            elem?.rentMaterialItemId !== undefined &&
            elem?.rentMaterialItemId !== "" &&
            elem?.warehouseId !== undefined &&
            elem?.warehouseId !== "" &&
            elem?.qty >= 0
          ) {
            // console.log("true");
            createStatus = true;
          } else {
            // console.log("false");
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      //
      if (createStatus) {
        //
        setLoading(true);
        createReturnRentMaterial({
          variables: {
            input: {
              desc: "",
              rentMaterialId: editData?._id,
              returnBy: values?.returnBy,
              returnDate: values?.returnDate,
              returnRentMaterialItems: returnRentMaterialItemsToSubmit,
            },
            inputRentMaterial: {
              desc: values?.remark,
              returnStatus: values?.returnStatus,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    values,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;

  //================== When Change Student ======================
  useEffect(() => {
    setFieldValue("academicYearId", academicYearVal?.id || "");
  }, [academicYearVal?.id]);

  useEffect(() => {
    setFieldValue("studentId", studentVal?.id || "");
  }, [studentVal?.id]);

  //
  useEffect(() => {
    if (editData) {
      // console.log("editData::::",editData);
      setAcademicYearVal({
        id: editData?.academicYearId?._id,
        title: editData?.academicYearId?.academicYear,
      });
      setStudentVal({
        id: editData?.studentId?._id,
        title:
          editData?.studentId?.englishName +
          " - " +
          editData?.studentId?.lastName +
          " " +
          editData?.studentId?.firstName,
      });

      setFieldValue("remark", editData?.desc);
      setFieldValue("returnStatus", editData?.returnStatus);

      if (editData?.rentMaterialItems) {
        let listRentItem = [];
        editData?.rentMaterialItems?.map((rowRent, index) => {
          // Find Return Item
          let returnMaterial = [];

          if (rowRent?.returnRentMaterialItems?.length > 0) {
            rowRent?.returnRentMaterialItems?.map((rowReturn, index) => {
              returnMaterial.push({
                key: index,
                returnId: rowReturn?.returnRentMaterialId?._id,
                returnDate: new Date(
                  rowReturn?.returnRentMaterialId?.returnDate,
                ),
                returnBy: rowReturn?.returnRentMaterialId?.returnBy,
                receiveBy: rowReturn?.returnRentMaterialId?.receiveBy?._id,
                isOld: true,
                isUpdate: false,
                condition: rowReturn?.condition,
                qty: rowReturn?.qty,
                desc: rowReturn?.desc,
                warehouseId: {
                  id: rowReturn?.warehouseId?._id,
                  title: rowReturn?.warehouseId?.warehouseName,
                },
              });
            });
          }

          listRentItem.push({
            materialId: {
              id: rowRent?.listMaterialUnitId?.materialId?._id,
              title: rowRent?.listMaterialUnitId?.materialId?.materialEnName,
              fullName: rowRent?.listMaterialUnitId?.materialId?.materialEnName,
            },
            listMaterialUnitId: {
              id: rowRent?.listMaterialUnitId?._id,
              title: rowRent?.listMaterialUnitId?.unitId?.unitKhName,
              imageSrc: rowRent?.listMaterialUnitId?.imageSrc,
            },
            rentMaterialItemId: rowRent?._id,
            returnMaterial: returnMaterial,
            qty: rowRent?.qty,
            condition: rowRent?.condition,
            key: Math.random() + index,
          });
        });
        setBookList(listRentItem);
      }
    }
  }, [editData, open]);

  // console.log("bookList::::",bookList);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">ទទួលសម្ភារៈមកវិញ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicYearVal}
                  setSelectedVal={setAcademicYearVal}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">ឈ្មោះសិស្ស</Typography>
                <SelectStudentByAcademicYear
                  selectedVal={studentVal}
                  setSelectedVal={setStudentVal}
                  academicYearId={academicYearVal?.id}
                  disabled={academicYearVal?.id ? false : true}
                  disabled={true}
                />
              </Grid>

              <Grid item xs={4} />

              <Grid item xs={4}>
                <Typography className="field-title">
                  អ្នកប្រគល់សម្ភារៈ
                </Typography>
                <TextField
                  placeholder="ឈ្មោះអ្នកប្រគល់"
                  value={values?.returnBy}
                  onChange={(val) =>
                    setFieldValue("returnBy", val.target.value)
                  }
                  fullWidth
                  size="small"
                />
                {!!errors.returnBy && touched.returnBy && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.returnBy}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">
                  កាលបរិច្ចេទប្រគល់
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    sx={{ width: "100%" }}
                    value={values?.returnDate}
                    onChange={(newValue) => {
                      setFieldValue("returnDate", newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={4}>
                <Typography className="field-title">
                  ស្ថានភាពបច្ចុប្បន្ន
                </Typography>
                <FormControl fullWidth size="small" className="search-field">
                  <Select
                    value={values?.returnStatus}
                    onChange={(val) =>
                      setFieldValue("returnStatus", val.target.value)
                    }
                  >
                    <MenuItem value="not_yet_returned">មិនទាន់ប្រគល់</MenuItem>
                    <MenuItem value="lose_some">បាត់</MenuItem>
                    <MenuItem value="return_some">ប្រគល់ខ្លះ</MenuItem>
                    <MenuItem value="return">ប្រគល់អស់</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <ListReturnBook
                  handleDeleteList={handleDeleteListBook}
                  handleDeleteSubList={handleDeleteSubList}
                  handleUpdateList={handleUpdateListBook}
                  handleUpdateListSubBook={handleUpdateListSubBook}
                  handleUpdateListSubBookChange={handleUpdateListSubBookChange}
                  handleAddList={handleAddListBook}
                  handleAddListSubBook={handleAddListSubBook}
                  warehouseId={warehouseVal?.id}
                  requiredField={requiredField}
                  bookList={bookList}
                  handleUpdateOldReturn={handleUpdateOldReturn}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">កំណត់សម្គាល់</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
